import React from 'react';
import { PolicyStatusCategoryRow } from '../../services/webFilter.service';

interface Props {
  rows: PolicyStatusCategoryRow[];
  isPdfMode?: boolean;
}

const WfPolicyStatus2: React.FC<Props> = ({ rows, isPdfMode }) => {
  // 2열 레이아웃: 좌(1~20), 우(21~)
  const half = Math.ceil(rows.length / 2);
  const left = rows.slice(0, half);
  const right = rows.slice(half);

  const renderRow = (r: PolicyStatusCategoryRow) => (
    <tr key={r.category}>
      <td>{r.category}</td>
      <td className="wf-policy-base">{r.policy}</td>
      <td className="wf-policy-except">{r.exceptCount > 0 ? `${r.exceptCount}건` : ''}</td>
    </tr>
  );

  return (
    <div className={`wf-section-card ${isPdfMode ? 'pdf-page-break' : ''}`}>
      {isPdfMode && <h2 className="wf-pdf-section-title">📋 정책 현황 (2/2)</h2>}
      <h3>■ 기준 정책 및 예외 신청 현황</h3>
      <div className="wf-policy-grid">
        <table className="wf-data-table wf-policy-table">
          <thead>
            <tr>
              <th>카테고리</th>
              <th>기준 정책</th>
              <th>예외처리(당월) 현황</th>
            </tr>
          </thead>
          <tbody>{left.map(renderRow)}</tbody>
        </table>
        <table className="wf-data-table wf-policy-table">
          <thead>
            <tr>
              <th>카테고리</th>
              <th>기준 정책</th>
              <th>예외처리(당월) 현황</th>
            </tr>
          </thead>
          <tbody>{right.map(renderRow)}</tbody>
        </table>
      </div>
    </div>
  );
};

export default WfPolicyStatus2;
